import { ContentfulClientApi } from 'contentful';
import { createContext } from 'react';

type ContentfulContextType = {
    contentfulClient: ContentfulClientApi<any>;
    contentfulData: any;
};

export const ContentfulContext = createContext<ContentfulContextType>({} as ContentfulContextType);
